import { ShopApiResponse } from 'models/ShopApiResponse';
import { ShopApiRequestParams } from 'models/ShopApiRequestParams';
import { determineShopSearchApiUrl } from './urls';
import { Environment } from 'models/Environment';
import { TargetMarket } from 'models/TargetMarket';
import { STATUS_CODES } from 'helpers/statusCodes';

export const getShopsFromApi = async ({
  category,
  searchTerm,
  keyword,
  account,
  sort,
  hasValidCertificate,
  page,
  environment,
  targetMarket
}: ShopApiRequestParams & {
  environment: Environment;
  targetMarket: TargetMarket;
}): Promise<ShopApiResponse> => {
  const url = new URL(determineShopSearchApiUrl(environment));
  if (keyword) {
    url.searchParams.append('keyword', keyword);
  } else if (account) {
    url.searchParams.append('account', account);
  } else if (searchTerm) {
    url.searchParams.append('searchTerm', searchTerm);
  }
  if (category) {
    url.searchParams.append('categories', category);
  }
  if (sort) {
    url.searchParams.append('sort', sort);
  }
  if (page) {
    url.searchParams.append('page', page);
  }
  if (hasValidCertificate) {
    url.searchParams.append('hasValidCertificate', 'true');
  }

  url.searchParams.append('targetMarket', targetMarket);

  const response: Response = await fetch(url.toString());

  if (!response.ok && response.status === STATUS_CODES.NOT_FOUND) {
    throw STATUS_CODES.GONE;
  }

  if (!response.ok && response.status >= STATUS_CODES.BAD_REQUEST) {
    throw response.status;
  }

  const responseJson = (await response.json()) as ShopApiResponse;

  if (
    response.ok &&
    responseJson &&
    responseJson.metaData &&
    responseJson.metaData.totalPageCount >= 1 &&
    page &&
    responseJson.metaData.totalPageCount < parseInt(page) + 1
  ) {
    throw STATUS_CODES.BAD_REQUEST;
  }

  return responseJson;
};
